module.exports = __webpack_public_path__ + "img/pic@2x (5).a6583bc3.png";